import { render, staticRenderFns } from "./InstitutionalTemplate.vue?vue&type=template&id=54df8144"
import script from "./InstitutionalTemplate.vue?vue&type=script&lang=js"
export * from "./InstitutionalTemplate.vue?vue&type=script&lang=js"
import style0 from "./InstitutionalTemplate.vue?vue&type=style&index=0&id=54df8144&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports